import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@material-ui/core";
import {
  SimpleLoading,
  PromotionalFooterPure,
  ButtonHLPure,
  InputFileESignHLPure,
  DialogSystemGLPure,
  SubtitlePageHLPure,
} from "../../pures";
import "./business-administration-certifiesSAT.css";
import { businessIconDefault } from "../../../assets/logos/icons";

const BusinessAdministrationCertifiesSATView = ({
  hideShowDetails,
  selectedUser,
  saveStatusForUser,
  token,
  createCertificate,
  changeImgFile,
  imgProfileSubtitle,
  handleChangeImgProfile,
  uploadFileCustom,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  showWarningRequesting,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  toggleWarningRequesting,
  message,
  imageProfile,
  nameComponentUser,
}) => {
  const { t } = useTranslation();
  const [selectedFileKey, setSelectedFileKey] = useState(null);
  const [errorFileKey, setErrorFile] = useState();
  const [selectedFileKeyName, setSelectedFileKeyName] = useState(
    selectedUser.companyCertificate.companyPrivateKeyName || ""
  );
  const [fileCER, setSelectedFileCer] = useState(null);
  const [errorFileCer, setErrorFileCer] = useState();
  const [selectedFileCerName, setSelectedFileCerName] = useState(
    selectedUser.companyCertificate.companyCertificateName || ""
  );

  //Function to select key file
  const handleFileKey = (e) => {
    if (e.target.files.length > 0) {
      let filename = e.target.files[0].name;
      let filenameArray = filename.split(".");
      let extension = filenameArray[filenameArray.length - 1];
      if (extension === "key" || extension === "pem") {
        setSelectedFileKey(e.target.files[0]);
        setErrorFile(false);
        setSelectedFileKeyName(filename);
      } else {
        setSelectedFileKey(null);
        setErrorFile(true);
        setSelectedFileKeyName(t("inputFileESignHLPure.notuploadDocument"));
        return false;
      }
    }
  };
  //Function to select cer file
  const handleFileCer = (e) => {
    if (e.target.files.length > 0) {
      let filename = e.target.files[0].name;
      let filenameArray = filename.split(".");
      let extension = filenameArray[filenameArray.length - 1];
      if (extension === "cer" || extension === "pem") {
        setSelectedFileCer(e.target.files[0]);
        setErrorFileCer(false);
        setSelectedFileCerName(filename);
      } else {
        setSelectedFileCer(null);
        setErrorFileCer(true);

        setSelectedFileCerName(t("inputFileESignHLPure.notuploadDocument"));
        return false;
      }
    }
  };

  //Save information for service createCertificate
  const handleSave = (e) => {
    let body = new FormData();
    body.append("fileCER", fileCER);
    for (const value of body.values()) {
      // console.log("valueee", value);
    }

    let certificateBody = new FormData();
    certificateBody.append("companyId", selectedUser.companyId);
    certificateBody.append("fileCER", fileCER);
    certificateBody.append("fileKey", selectedFileKey);

    for (const value of certificateBody.values()) {
      // console.log("valueee", value);
    }
    createCertificate(token, body, certificateBody);
  };

  return (
    <Grid
      item
      lg={12}
      md={12}
      sm={12}
      xs={12}
      className="userAdministrationAddNewUserView-wrapper"
    >
      {showLoadingRequesting ? (
        <DialogSystemGLPure
          showLoadingRequesting={showLoadingRequesting}
          toggleLoadingRequesting={toggleLoadingRequesting}
        />
      ) : null}
      <>
        <Grid
          item
          lg={12}
          md={12}
          xs={12}
          sm={12}
          className="businessAdministrationCertifiesSATView-header"
        >
          <SubtitlePageHLPure
            subtitle={
              t("businessAdministrationPanelView.certifiesSAT") +
              " " +
              selectedUser.clientName
            }
            imgProfile={businessIconDefault}
            profileImg={selectedUser?.imgProfile || imageProfile}
            tooltipShow
            positionTooltip={"bottom"}
            titleTooltip={t("businessAdministrationAddressView.tooltip.img.title")}
            descriptionTooltip={t("businessAdministrationAddressView.tooltip.img.description")}
            informationIcon={false}
            // handleChangeImage={handleChangeImgProfile}
            uploadFile={(e) => uploadFileCustom(e)}
            changeImgFile={changeImgFile}
            justShowImg={false}
            openTooltipDescription={false}
          />
        </Grid>
        <Grid
          item
          className="businessAdministrationCertifiesSATView-body"
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
        >
          {/*Container primera seccion de items, fila*/}
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="businessAdministrationCertifiesSATView-form"
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              es={3}
              className="businessAdministrationCertifiesSATView-col1"
            >
              <Grid
                item
                className="businessAdministrationCertifiesSATView-buttonHLPure"
              >
                <InputFileESignHLPure
                  messageBtn={t("businessAdministrationCertifiesSATView.certificate")}
                  acceptType={".cer"}
                  handleFileESignChange={handleFileCer}
                  selectedFile={fileCER}
                  selectedFileName={selectedFileCerName}
                  errorFile={errorFileCer}
                />
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
              className="businessAdministrationCertifiesSATView-information"
            >
              <Grid item xs={12} lg={5} md={5} sm={6} es={6}>
                <p>{t("businessAdministrationCertifiesSATView.legal.name")} {selectedUser.clientName}</p>
                <p>{t("businessAdministrationCertifiesSATView.rfc")} {selectedUser.company.rfc}</p>
                <p>{t("businessAdministrationCertifiesSATView.valid")} {selectedUser.lastModificationDate}</p>
              </Grid>
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="businessAdministrationCertifiesSATView-col2"
            >
              <Grid
                item
                className="businessAdministrationCertifiesSATView-searchHLPure"
              >
                <InputFileESignHLPure
                  messageBtn={t("businessAdministrationCertifiesSATView.key")}
                  acceptType={".key"}
                  handleFileESignChange={handleFileKey}
                  selectedFile={selectedFileKey}
                  selectedFileName={selectedFileKeyName}
                  errorFile={errorFileKey}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="businessAdministrationCertifiesSATView-btnGroup"
          >
            <Grid className="businessAdministrationCertifiesSATView-spaceBtns">
              <ButtonHLPure
                primary={false}
                nameBtn={t("button.cancel")}
                onClickBtn={hideShowDetails}
              />
            </Grid>
            <ButtonHLPure
              primary
              nameBtn={t("button.save")}
              onClickBtn={(e) => handleSave(e)}
            />
          </Grid>
          <DialogSystemGLPure
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showWarningRequesting={showWarningRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleWarningRequesting={toggleWarningRequesting}
            message={message}
          />
        </Grid>
      </>
    </Grid>
  );
};

export default BusinessAdministrationCertifiesSATView;
